import type { MetricRecordData } from "@/types/metrics/contracts"

export function getMetricUnit(
  metric: Pick<MetricRecordData, "metric_manager" | "metric_metadata">,
): string {
  const metadata = metric.metric_metadata
  if (metric.metric_manager !== "manager_python") {
    return metadata?.unit_abbreviation ?? ""
  }
  const definition =
    metadata && "python_metric" in metadata ? metadata.python_metric : null
  const artifact =
    definition && typeof definition === "object" && "artifact" in definition
      ? definition.artifact
      : null
  return artifact &&
    typeof artifact === "object" &&
    "unit" in artifact &&
    typeof artifact.unit === "string"
    ? artifact.unit
    : ""
}
